import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';

@Injectable({
  providedIn: 'root'
})
export class SymptomsCheckerService {

  constructor(private genericService: GenericUtilityService) { }
  initialQuestions(data:any, language:any)
  {
    let callingAction = "initial_questions" + "?LanguageCode=" + language;
    return this.genericService.ApiPostMethodSymptoms(callingAction,data);
  }
  startOver(data:any, language:any)
  {
    let callingAction = "start_over" + "?LanguageCode=" + language;
    return this.genericService.ApiPostMethodSymptoms(callingAction,data);
  }
  initialSymptoms(data:any, language:any)
  {
    let callingAction = "initial_symptoms" + "?LanguageCode=" + language;
    return this.genericService.ApiPostMethodSymptoms(callingAction,data);
  }

  sendSymptoms(url: any, data:any, language: any)
  {
    let callingAction = url + "?LanguageCode=" + language;
    return this.genericService.ApiPostMethodSymptoms(callingAction,data);
  }
  symptom_info(data: any, destination_utl: any, language: any)
  {
    let callingAction = destination_utl + "?LanguageCode=" + language;

    return this.genericService.ApiPostMethodSymptoms(callingAction,data);
  }
  start_over(data:any, language:any)
  {
    let callingAction = 'start_over' + "?LanguageCode=" + language;
    return this.genericService.ApiPostMethodSymptoms(callingAction,data);
  }
  IcdPredictionSaveData(data:any, language:any)
  {
    let callingAction = 'IcdPredictionSaveData' + "?LanguageCode=" + language;
    return this.genericService.ApiPostMethod('encounter', callingAction,data);
  }
}
